import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { CreateIpRulesCommand } from 'src/app/core/api/models';
import { ApiTokenService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { PeriodType } from 'src/app/core/enums/period-type.enum';
import { SetRateLimitRuleModel } from 'src/app/core/models/set-rate-limit-rule.model';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { GetRulesByIpDto } from '../../../../../core/api/models/get-rules-by-ip-dto';
import { UpdateIpRulesCommand } from '../../../../../core/api/models/update-ip-rules-command';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { CreateRulesFieldsComponent } from "../../shared/create-rules-fields/create-rules-fields.component";

@Component({
    selector: 'app-ip-rules-form',
    templateUrl: './ip-rules-form.component.html',
    imports: [BaseFormModule, CreateRulesFieldsComponent]
})
export class IpRulesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() apiTokenId;
  @Input() rulesModel: GetRulesByIpDto;
  @Input() isEdit;

  model: CreateIpRulesCommand = {};
  newRulesModel: SetRateLimitRuleModel[] = [];
  createRulesForms: FormGroup[] = [];

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(protected currentService: ApiTokenService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.fields = 'pages.ipRules.form.fields.';
      this.pageVocabs = 'pages.ipRules.form.';
      this.title = 'pages.ipRules.title';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  //#region init methods

  initModel(): void {
    try {
      if (this.rulesModel && this.isEdit) {
        this.newRulesModel = Object.assign(
          [],
          this.rulesModel.apiIpRules[0].rules
        );
        this.newRulesModel.forEach((_element, i) => {
          let periodType = this.newRulesModel[i].period.substr(
            this.newRulesModel[i].period.length - 1
          );
          this.newRulesModel[i].periodType =
            periodType == 'd'
              ? PeriodType.Daily
              : periodType == 'h'
              ? PeriodType.Hour
              : periodType == 'm'
              ? PeriodType.Minute
              : PeriodType.Second;
          this.newRulesModel[i].period = this.newRulesModel[i].period.replace(
            /\D/g,
            ''
          );
        });
      } else {
        this.newRulesModel = [];
        this.onAddIpRules();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      period: new FormControl(''),
      limit: new FormControl(''),
      endpoint: new FormControl(''),
      periodType: new FormControl(''),
    });
  }

  isValidCreateRulesForms(): boolean {
    try {
      let result: boolean = true;

      this.createRulesForms.forEach((form) => {
        if (form.invalid) {
          result = false;
          form.markAllAsTouched();
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  //#endregion

  //#region api

  //Create
  baseCreateApi(model: CreateIpRulesCommand): void {
    this.unSubs();

    this.loading = true;
    model.apiTokenId = this.apiTokenId;
    this.setPeriodType();
    model.ipRules = this.newRulesModel;
    this.currentService
      .apiTokenCreateIpRulesPost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateIpRulesCommand): void {
    this.unSubs();

    this.loading = true;
    model.apiTokenId = this.apiTokenId;
    this.setPeriodType();
    model.ipRules = this.newRulesModel;
    this.currentService
      .apiTokenUpdateIpRulesPost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (this.loading) return;

      if (!this.isValidForm(this.form, this.tagName)) return;

      if (!this.isValidCreateRulesForms()) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;

    if (this.isEdit) this.baseUpdateApi(this.model);
    else this.baseCreateApi(this.model);
  }

  onClose() {
    this.output_closPage.emit(true);
  }

  //#region ipRules

  onAddIpRules() {
    try {
      this.newRulesModel.push({
        endpoint: '',
        limit: 0,
        period: '',
        periodType: PeriodType.Second,
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  onRemoveIpRules(index: number) {
    try {
      if (this.newRulesModel.length > 1 || this.isEdit)
        this.newRulesModel.splice(index, 1);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  setPeriodType() {
    try {
      this.newRulesModel.forEach((element) => {
        if (this.isEdit && element.periodType) {
          element.period = element.period.replace(/\D/g, '');
        }

        if (!isNaN(+element.period)) {
          element.period =
            element.periodType == PeriodType.Daily
              ? element.period + 'd'
              : element.periodType == PeriodType.Hour
              ? element.period + 'h'
              : element.periodType == PeriodType.Minute
              ? element.period + 'm'
              : element.period + 's';
        }
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }
  //#endregion
}
